

interface IValidation {
    err: number;
    msg?: string;
}

export class LblValidator {

    validation:Map<string,IValidation>= new Map

    err(id:string) {
        const v=this.validation.get(id)
        if (!v) return false;
        if (!v.err) return false;
        return true;
    }

    msg(id:string) {
        const v=this.validation.get(id)
        if (!v) return "";
        if (!v.msg) return "";
        return v.msg;
    }

    private expect_full(obj:any, id: string) {
        if (!obj[id]) this.validation.set(id,{ err:1, msg: "Wartość wymagana" })
        else this.validation.set(id,{err:1 })
    }

    public async validate(l: any, status:string) {
        this.validation= new Map
        this.expect_full(l, "email_do_akceptacji")
    }

}